export enum CardButtonVariant {
	Brand = 'brand',
	Green = 'green',
	LightBorder = 'light-border'
}
